<div class="filter">
    <button
      mat-flat-button
      class="text-600 flex-wrap"
      [class.btn--small]="size === 'xs'"
      (click)="onFilterButtonClicked()"
    >
    <app-icon name="outline-filter" class="align-middle text-400 mr-1" size="xs"></app-icon>
    {{ "Buttons.Filter" | translate }}
    </button>
  </div>

